<template>
    <div>
      <div class="page-404-bg "></div>
      
      <h1 class="page-404-error-code"><strong>404</strong></h1>
      <h2 class="page-404-subheader">OOPS!</h2>
      <h3 class="page-404-text" v-html="$t('message')">
      </h3>
    </div>
</template>
<i18n>
{
  "en": {
    "message": "Something went wrong or this page does not exist. <br> After 5 seconds you will be redirected to the main page."
  },
  "ru": {
    "message": "Что-то пошло не так или эта страница не существует.<br> Через 5 секунд вы будете переадресованы на главную страницу"
  }
}
</i18n>
<script>

    export default {
    created () {
              setTimeout(() => {
            this.redirect()
        }, 5000);
      // Can set query parameter here for auth redirect or just do it silently in login redirect.
    },
    methods: {
      redirect () {
        this.$parent.$router.push('/')
      }
    }
  }
  </script>
  <style>
    .page-404-bg {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }

    .page-404-header,
    .page-404-error-code,
    .page-404-subheader,
    .page-404-text,
    .page-404-form {
      position: relative;

      padding: 0 30px;

      text-align: center;
    }

    .page-404-header {
      width: 100%;
      padding: 20px 0;

      box-shadow: 0 4px 0 rgba(0,0,0,.1);
    }

    .page-404-error-code {
      margin-top: 60px;

      color: rgba(0,0,0,.5);
      text-shadow: 0 4px 0 rgba(0,0,0,.1);

      font-size: 120px;
      font-weight: 700;
      line-height: 140px;
    }

    .page-404-subheader,
    .page-404-text {
      margin-bottom: 60px;

      color: rgba(0,0,0,.5);

      font-weight: 600;
    }

    .page-404-subheader {
      font-size: 50px;
    }

    .page-404-subheader:after {
      position: absolute;
      bottom: -30px;
      left: 50%;

      display: block;

      width: 40px;
      height: 4px;
      margin-left: -20px;

      content: "";

      background: rgba(0,0,0,.2);
    }

    .page-404-text {
      font-size: 20px;
    }

    .page-404-form {
      max-width: 500px;
      margin: 0 auto 60px auto;
    }

    .page-404-form * {
      margin: 0 !important;

      border: none !important;
    }

    .page-404-form .btn {
      background: rgba(0, 0, 0, .3);
    }
  </style>